import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";

import { formatDateWithTime } from "../../config";

import styles from "./TicketsRow.module.css";
import { oldifyTicket } from "../../store/actions/TicketsActions";

class TicketRow extends Component {

  constructor(props) {
    super(props);

  }

  dehighlight = ( id ) => {
    if( this.props.new_tickets_ids.includes(this.props.ticket.CardID) )
      this.props.oldifyTicket( id );
  }

  render() {
    let { id, ticket, columns, new_tickets_ids } = this.props;

    return (
      <tr key={ticket.CardID} className={new_tickets_ids.includes(ticket.CardID)? styles.newTicket : ""} onMouseEnter={this.dehighlight.bind(this, ticket.CardID)} >
        <td>{id}</td>
        {columns.map((col, id) => {
          //if column consists of more than one value
          if (Array.isArray(col.key)) {
            let values = [];
            col.key.forEach((k, i) => {
              let val = _.get(ticket, k);
              if (val) values.push(val);
            });

            if (values.length > 0) {
              return (
                <td>
                  {values.map(v => (
                    <tr>{v}</tr>
                  ))}
                </td>
              );
            } else {
              return (
                <td>
                  <span>Unknown</span>
                </td>
              );
            }
          }

          let value = _.get(ticket, col.key);
          if (col.replace) {
            col.replace.forEach(r => {
              if (r.key === value) {
                value = r.value;
              }
            });
          }

          if (col.type && col.type === "date") {
            value = formatDateWithTime(value);
          }

          return (
            <td
              key={id}
            >
              {value}
            </td>
          );
        })}
      </tr>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    oldifyTicket: bindActionCreators(oldifyTicket, dispatch)
  }
}

function mapStateToProps({ tickets }) {
  return {
    new_tickets_ids: tickets.new_tickets_ids
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TicketRow);